import { ThunkDispatch } from 'redux-thunk';
import { AnyAction, combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

import user from './user';
import story from './story';
import card from './card';
import editor from './editor';
import settings from './settings';

const rootReducer = combineReducers({
	user,
	story,
	card,
	editor,
	settings,
	form: formReducer,
});

export type ClientReducerState = ReturnType<typeof rootReducer>;

export type ClientThunkDispatch<A extends AnyAction = AnyAction> = ThunkDispatch<ClientReducerState, void, A>;

export type ClientThunkAction<A extends AnyAction = AnyAction, R = void> = (
	dispatch: ClientThunkDispatch<A>,
	getState: () => ClientReducerState
) => Promise<R>;

export const useClientSelector: TypedUseSelectorHook<ClientReducerState> = useSelector;

export default rootReducer;
